import { render, staticRenderFns } from "./ProductInquiry.vue?vue&type=template&id=7c5e8ddc&scoped=true&"
import script from "./ProductInquiry.vue?vue&type=script&lang=ts&"
export * from "./ProductInquiry.vue?vue&type=script&lang=ts&"
import style0 from "./ProductInquiry.vue?vue&type=style&index=0&id=7c5e8ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5e8ddc",
  null
  
)

export default component.exports